// extracted by mini-css-extract-plugin
module.exports = {"link":"_-_-pharmacy-src-user-followUserButton-followUserButton__link--3qPEB"};